
define('PartLookup', [
	'PartLookup.Form.View',
  'PartLookup.Base.View',
  
  'PartLookup.Model',
], function (
	PartLookupFormView,
  PartLookupBaseView,

  PartLookupModel
) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {

      var pageTypeComponent = application.getComponent('PageType');
			var layout = application.getComponent('Layout');
			var searchComponent = application.getComponent('Search');

			if (layout) {
				layout.registerView('PartLookupModelSearch', function () {
					return new PartLookupFormView({ application: application });
				});
				// layout.registerView('ModelNumberSearchView', function () {
				// 	return new PartLookupFormView({ application: application });
				// });
			}

			if (pageTypeComponent) {

				pageTypeComponent.registerPageType({
					name: 'ModelInfo',
					routes: [
            'model-search',
            'model-search/:modelSearchInput',
            'model-search/:modelSearchInput/:selectedAssemblyId'
          ],
					view: PartLookupBaseView,
					options: {
            application: application,
            searchComponent: searchComponent,
            model: new PartLookupModel()
          }
				});

			}
		}
	};
});
